module.exports = __webpack_public_path__ + "static/media/location-verde_old.e0aa02d1.svg";